import { render, staticRenderFns } from "./ReportFolderButton.vue?vue&type=template&id=4c8d4bf8"
import script from "./ReportFolderButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportFolderButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports